import * as React from "react";
import { OrgansSystems } from "shared";
import { ReactComponent as PsychiatricSVGIcon } from "./assets/organSystems/PSY.svg";

export const organsSystemIcons = (width = 26, height = 26, color = "") => ({
  [OrgansSystems.BLD]: {
    icon: <i className="fal fa-tint"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.FLD_ELCT]: {
    icon: <i className="fal fa-sliders-v"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.CVD]: {
    icon: <i className="fal fa-heartbeat"></i>,
    viewBox: "0 0 512 512",
  },

  [OrgansSystems.ENDO]: {
    icon: <i className="fal fa-transgender-alt"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.GI]: {
    icon: <i className="fal fa-stomach"></i>,
    viewBox: "0 0 512 512",
    marginTop: 0,
  },
  [OrgansSystems.GU]: {
    icon: <i className="fal fa-kidneys"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.HEM]: {
    icon: <i className="fal fa-tint"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.IMM]: {
    icon: <i className="fal fa-shield-virus"></i>,
    viewBox: "0 0 64 64",
  },
  [OrgansSystems.INF]: {
    icon: <i className="fal fa-bacteria"></i>,
    viewBox: "0 0 200 200",
  },
  [OrgansSystems.LYM]: {
    icon: <i className="fal fa-code-merge"></i>,
    viewBox: "0 0 64 64",
  },
  [OrgansSystems.MSK]: {
    icon: <i className="fal fa-bone"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.NEU]: {
    icon: <i className="fal fa-brain"></i>,
    viewBox: "0 0 64 64",
  },
  [OrgansSystems.ONCNEU]: {
    icon: <i className="fal fa-disease"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.ONC]: {
    icon: <i className="fal fa-disease"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.OTH]: {
    icon: <i className="fal fa-ear"></i>,
    viewBox: "0 0 64 64",
  },
  [OrgansSystems.RESP]: {
    icon: <i className="fal fa-lungs"></i>,
    viewBox: "0 0 512 512",
    marginTop: "-5px",
  },
  [OrgansSystems.SKIN]: {
    icon: <i className="fal fa-allergies"></i>,
    viewBox: "0 0 64 64",
  },
  [OrgansSystems.META]: {
    icon: <i className="fal fa-cogs"></i>,
    viewBox: "0 0 512 512",
  },
  [OrgansSystems.PSY]: {
    marginTop: "10px",
    icon: <PsychiatricSVGIcon width={width} height={height} stroke={color} />,
    viewBox: "0 0 512 512",
  },
});
